<template>
  <el-dialog
    :title="$t('71')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    append-to-body
    width="800px"
    class="staff-wrapper"
    @closed="closeDialog"
  >
    <el-row class="header">
      <el-col class="name">
        <span>{{ $t('payroll_management_31') }}：</span>
        <span>{{ staffInfo.staff_name }}</span
        ><span v-if="staffInfo.staff_code">({{ staffInfo.staff_code }})</span>
      </el-col>
      <el-col>
        <span>{{ $t('27') }}：</span>
        <span>{{ staffInfo.department_name }}</span>
      </el-col>
      <el-col :span="12">
        <span>{{ $t('28') }}：</span>
        <span>{{ staffInfo.hire_date }}</span>
      </el-col>
      <el-col :span="12">
        <span>{{ $t('29') }}：</span>
        <span>{{ staffInfo.leave_date }}</span>
      </el-col>
    </el-row>
    <el-tabs v-model="activeName" class="main" @tab-click="handleClick">
      <!-- 基础信息 -->
      <el-tab-pane :label="$t('312')" name="info"></el-tab-pane>
      <template v-if="staffInfo.settlement_type != 99">
        <!-- 薪资结构 -->
        <el-tab-pane :label="$t('424')" name="salary"></el-tab-pane>
        <!-- 抵扣项 预扣税时置灰 -->
        <el-tab-pane :disabled="staffInfo.tax_deduction_status === '4'" name="deduct">
          <template slot="label">
            {{ $t('444') }}
            <el-tooltip class="tooltip" effect="dark" :content="$t('payroll_salary_17')" placement="top-start">
              <div>
                <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
              </div>
            </el-tooltip>
          </template>
        </el-tab-pane>
        <!-- 税 -->
        <el-tab-pane :label="$t('421')" name="tax"></el-tab-pane>
        <!-- 社保 -->
        <el-tab-pane :label="$t('420')" name="social"></el-tab-pane>
        <!-- 公积金 -->
        <el-tab-pane :label="$t('1490')" name="fund"></el-tab-pane>
      </template>
    </el-tabs>
    <el-form class="staff-form" :model="staffInfo" :rules="rules" label-position="left" ref="staffForm" :inline="true">
      <!-- 基本信息-->
      <basic-info
        ref="info"
        v-if="showDetail"
        :staff-info="staffInfo"
        :row="row"
        :show="show"
        @bankChange="bankChange"
        @changeTax="changeTax"
        @taxIdBlur="taxIdBlur"
      ></basic-info>
      <template v-if="staffInfo.settlement_type != 99 && showDetail">
        <!-- 薪资结构-->
        <basic-salary ref="salary" :show="show" :staff-info="staffInfo"></basic-salary>
        <!-- 抵扣项 预扣税时不展示-->
        <deduct-info
          ref="deduct"
          v-if="staffInfo.tax_deduction_status !== '4'"
          :staff-info="staffInfo"
          :show="show"
          @blurDeduction10="blurDeduction10"
          @blurDeduction11="blurDeduction11"
          @blurDeduction13="blurDeduction13"
          @blurDeduction14="blurDeduction14"
        ></deduct-info>
        <!-- 税-->
        <tax-info :show="show" ref="tax" :staff-info="staffInfo"></tax-info>
        <!-- 社保 -->
        <social-provident :show="show" ref="social" :staff-info="staffInfo" />
        <!-- 公积金 -->
        <fund-provident :show="show" ref="fund" :staff-info="staffInfo" />
      </template>
    </el-form>
    <!-- 提交 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerBack"> {{ show ? $t('652') : $t('66') }} </el-button>
      <el-button v-if="!show" type="primary" @click="submitForm('staffForm')">{{ $t('67') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import '../directive.js'
import {
  payrollSubStaffDetail,
  payrollSubStaffDetailSave,
  payrollStaffDetail,
  payrollStaffDetailSave
} from '@/api/payroll'
import basicInfo from './basic-info'
import basicSalary from './basic-salary'
import taxInfo from './tax-info'
import deductInfo from './deduct-info.vue'
import fundProvident from './fund-providen.vue'
import socialProvident from './social-provident'

const validateTax = (rule, value, callback) => {
  const { message } = rule
  if (!value) return callback(new Error(message))
  return callback()
}
const validatePass = (rule, value, callback) => {
  const { max, message } = rule
  if (value && value > max) return callback(new Error(message))
  return callback()
}
export const validateDeduction = (rule, value, callback) => {
  const { arr, message, max, mix, mixMax } = rule
  if (mix && mix > mixMax) return callback(new Error(message))
  if (max && value && value > max) return callback(new Error(message))
  if (arr && !arr.includes(Number(value))) return callback(new Error(message))
  return callback()
}
export default {
  components: {
    basicInfo,
    basicSalary,
    taxInfo,
    deductInfo,
    fundProvident,
    socialProvident
  },
  props: {
    staffId: String,
    subProjectId: String,
    type: String,
    show: Boolean
  },
  data() {
    return {
      visible: false,
      activeName: 'info',
      staffInfo: {},
      showDetail: false,
      row: {},
      rules: {
        provident_fund_status: [{ required: true, message: this.$t('221') }],
        tax_deduction_status: [{ required: true, message: this.$t('958'), trigger: 'change' }],
        social_security_status: [{ required: true, message: this.$t('959'), trigger: 'change' }],
        bank_card_no: [
          { required: true, message: this.$t('960'), trigger: 'blur' },
          { min: 10, max: 12, message: this.$t('961'), trigger: 'blur' }
        ],
        // tax_id: [{ required: true, message: this.$t('962'), trigger: 'blur' }],
        tax_id: [{ required: true, validator: validateTax, message: this.$t('962'), trigger: 'blur' }],
        salary_day: [{ required: true, message: this.$t('963'), trigger: 'blur' }],
        // salary_basic: [{ required: true, message: this.$t('964'), trigger: 'blur' }],
        salary_update_start_date: [{ required: true, message: this.$t('966'), trigger: 'change' }],
        salary_basic_later: [{ required: true, message: this.$t('965'), trigger: 'blur' }],
        // 夫妻抵扣
        tax_deduction_7: [
          {
            trigger: 'blur',
            validator: validateDeduction,
            arr: [0, 60000, 120000],
            message: this.$t('payroll_salary_7')
          }
        ],
        // 子女抵扣
        tax_deduction_8: [
          {
            trigger: 'blur',
            validator: validateDeduction,
            arr: [0, 30000, 60000, 90000],
            message: this.$t('payroll_salary_8')
          }
        ],
        // 父母抵扣
        tax_deduction_9: [
          {
            trigger: 'blur',
            validator: validateDeduction,
            arr: [0, 30000, 60000, 90000, 120000],
            message: this.$t('payroll_salary_9')
          }
        ],
        // 人寿保险
        tax_deduction_10: [
          {
            trigger: 'blur',
            validator: validateDeduction,
            mix: 0,
            max: 100000,
            mixMax: 100000,
            message: this.$t('payroll_deduction_error_2')
          }
        ],
        // 医疗保险
        tax_deduction_11: [
          {
            trigger: 'blur',
            validator: validateDeduction,
            mix: 0,
            max: 25000,
            mixMax: 100000,
            message: this.$t('payroll_deduction_error_3')
          }
        ],
        // 父母医疗保险
        tax_deduction_12: [
          { trigger: 'blur', validator: validatePass, max: 15000, message: this.$t('payroll_deduction_error_5') }
        ],
        // 超级储蓄基金投资
        tax_deduction_13: [
          {
            trigger: 'blur',
            validator: validateDeduction,
            mix: 0,
            max: 200000,
            mixMax: 500000,
            message: this.$t('payroll_deduction_error_6')
          }
        ],
        // 共同基金
        tax_deduction_14: [
          {
            trigger: 'blur',
            validator: validateDeduction,
            mix: 0,
            max: 500000,
            mixMax: 500000,
            message: this.$t('payroll_deduction_error_7')
          }
        ],
        tax_deduction_15: [
          { message: this.$t('payroll_deduction_error_8'), trigger: 'blur', max: 100000, validator: validatePass }
        ],
        // 社保
        salary_last_ss: [{ required: true, message: this.$t('1593'), trigger: 'blur' }],
        // 累计已交公积金
        salary_last_pf: [{ required: true, message: this.$t('1593'), trigger: 'blur' }],
        // 公司公积金缴存比例
        provident_fund_company: [{ required: true, message: this.$t('1593'), trigger: 'blur' }],
        // 个人公积金缴存比例缴存比例
        provident_fund: [{ required: true, message: this.$t('1593'), trigger: 'blur' }],
        // 本年累计固定收入
        salary_last_fix: [{ required: true, message: this.$t('1593'), trigger: 'blur' }],
        // 本年累计固定收入税额
        salary_year_accumulate_fix_tax: [{ required: true, message: this.$t('1593'), trigger: 'blur' }],
        // 本年累计非固定收入
        salary_year_accumulate_notfix: [{ required: true, message: this.$t('1593'), trigger: 'blur' }],
        // 本年累计非固定收入税额
        salary_year_accumulate_notfix_tax: [{ required: true, message: this.$t('1593'), trigger: 'blur' }],
        tax_rule: [{ required: true, message: this.$t('1593'), trigger: 'change' }],
        tax_rate: [{ required: true, message: this.$t('1593'), trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(n) {
      if (n) {
        this.loadStaffDetail()
      }
    }
  },
  methods: {
    init(row) {
      this.row = row
      this.activeName = 'info'
      this.visible = true
    },
    handleClick() {
      this.$refs[this.activeName].$el.scrollIntoView()
    },
    // 银行账号长度校验
    bankChange(min, max) {
      this.rules.bank_card_no[1].min = min
      this.rules.bank_card_no[1].max = max
    },
    async loadStaffDetail() {
      let res
      if (this.type === 'salay') {
        res = await payrollStaffDetail({
          staff_id: this.staffId
        })
      } else {
        res = await payrollSubStaffDetail({
          staff_id: this.staffId,
          sub_project_id: this.subProjectId
        })
      }
      if (res && res.code === 1) {
        if (this.show) {
          const last = res.data.salary.last || res.data.salary
          last.forEach(item => {
            item.list.forEach(citem => {
              citem.val =
                citem.val && citem.val.toString().replace(/(^|\s)\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
            })
          })
          const keys = Object.keys(res.data)
          keys.forEach(item => {
            const tax = !isNaN(Number(item.split('tax_deduction_')[1]))
            const key = [
              'salary_last_fix',
              'salary_year_accumulate_fix_tax',
              'salary_year_accumulate_notfix',
              'salary_year_accumulate_notfix_tax',
              'salary_last_ss',
              'salary_last_pf'
            ]
            const other = key.includes(item)
            if (tax || other) {
              res.data[item] =
                res.data[item] &&
                res.data[item].toString().replace(/(^|\s)\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
            }
          })
        }
        this.staffInfo = res.data
        this.staffInfo.staff_id = res.data.staff_info_id
        this.showDetail = true
      }

      // tax_deduction_status 3个人所得税 4预扣税 2不扣税
      const deduction_status = this.staffInfo.tax_deduction_status
      this.staffInfo.tax_deduction_status = deduction_status === '1' ? '3' : deduction_status
      const provident = this.staffInfo.provident_fund_status
      const social = this.staffInfo.social_security_status
      const tax_rate = this.staffInfo.tax_rate
      const tax_rule = this.staffInfo.tax_rule
      this.$set(this.staffInfo, 'social_security_status', social)
      this.$set(this.staffInfo, 'provident_fund_status', provident)
      this.$set(this.staffInfo, 'tax_rate', tax_rate || '')
      this.$set(this.staffInfo, 'tax_rule', !tax_rule || tax_rule === '0' ? '' : tax_rule)
      this.rules.tax_id[0].required =
        ['3', '4'].includes(this.staffInfo.tax_deduction_status) ||
        (this.staffInfo.tax_deduction_status === '2' && this.staffInfo.nationality !== 'TH')
    },
    // 扣税状态
    changeTax(item) {
      this.$refs.staffForm.clearValidate('tax_id')
      // 税为个人所得税、预扣税时，Tax ID为必填，其他为非必填
      this.rules.tax_id[0].required = item !== '2' || this.staffInfo.nationality !== 'TH'
      this.rules.tax_id[0].message =
        item === '2' && this.staffInfo.nationality !== 'TH' ? this.$t('968') : this.$t('962')
    },
    taxIdBlur(val) {
      if (!val && this.staffInfo.tax_deduction_status === '2' && this.staffInfo.nationality === 'TH') {
        this.rules.tax_id[0].required = false
        this.rules.tax_id[0].message = this.$t('962')
      }
    },
    blurDeduction10(val) {
      const deduction11 = Number(this.staffInfo.tax_deduction_11) // 医疗保险
      this.$refs.staffForm.clearValidate('tax_deduction_10')
      this.rules.tax_deduction_10[0].mix = Number(val) + deduction11
    },
    blurDeduction11(val) {
      const deduction10 = Number(this.staffInfo.tax_deduction_10) // 人寿保险
      this.$refs.staffForm.clearValidate('tax_deduction_11')
      this.rules.tax_deduction_11[0].mix = Number(val) + deduction10
      const mixMax = this.rules.tax_deduction_11[0].mixMax
      if (Number(val) + deduction10 > mixMax) {
        this.rules.tax_deduction_11[0].message = this.$t('payroll_deduction_error_16')
      }
    },
    blurDeduction13(val) {
      const deduction14 = Number(this.staffInfo.tax_deduction_14) // 医疗保险
      this.$refs.staffForm.clearValidate('tax_deduction_13')
      this.rules.tax_deduction_13[0].mix = Number(val) + deduction14
      const mixMax = this.rules.tax_deduction_13[0].mixMax
      if (Number(val) + deduction14 > mixMax) {
        this.rules.tax_deduction_13[0].message = this.$t('payroll_deduction_error_17')
      }
    },
    blurDeduction14(val) {
      const deduction13 = Number(this.staffInfo.tax_deduction_13) // 超级储蓄基金投资
      this.$refs.staffForm.clearValidate('tax_deduction_14')
      this.rules.tax_deduction_14[0].mix = Number(val) + deduction13
      const mixMax = this.rules.tax_deduction_14[0].mixMax
      if (Number(val) + deduction13 > mixMax) {
        this.rules.tax_deduction_14[0].message = this.$t('payroll_deduction_error_17')
      }
    },
    handlerBack() {
      this.visible = false
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 是否有调薪
          if (this.staffInfo.is_salary_update === '1') {
            this.staffInfo.salary_basic_last = this.staffInfo.salary_basic
            this.staffInfo.salary_pos_last = this.staffInfo.salary_pos
            this.staffInfo.salary_exp_last = this.staffInfo.salary_exp
            this.staffInfo.salary_computer_last = this.staffInfo.salary_computer
            this.staffInfo.salary_rent_last = this.staffInfo.salary_rent
            this.staffInfo.salary_other_fix_last = this.staffInfo.salary_other_fix
          }
          this.doSubmit()
        } else {
          this.$message({
            message: this.$t('payroll_salary_5'),
            type: 'warning'
          })
          return false
        }
      })
    },
    async doSubmit() {
      if (this.type === 'salay') {
        const res = await payrollStaffDetailSave(this.staffInfo)
        if (res && res.code === 1) {
          this.$emit('getListData')
          this.visible = false
        }
      } else {
        const res = await payrollSubStaffDetailSave(this.staffInfo)
        if (res && res.code === 1) {
          this.$emit('getListData')
          this.visible = false
        }
      }
    },
    closeDialog() {
      this.$refs.staffForm.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.staff-wrapper {
  /deep/ .el-dialog {
    &__body {
      display: flex;
      flex-direction: column;
      padding-top: 24px;
      padding-bottom: 0;
    }
    &__footer {
      padding: 12px 24px;
      .el-button + .el-button {
        margin-left: 16px;
      }
    }
  }
  .header {
    color: #595959;
    .el-col {
      line-height: 28px;
      margin-bottom: 5px;
      span {
        margin-right: 10px;
      }
    }
    .name {
      font-size: 18px;
      font-weight: bolder;
      margin-bottom: 10px;
      color: #262626;
    }
  }
  .staff-form {
    flex: 1;
    overflow: auto;
    /deep/ .el-form-item {
      width: 48%;
      padding-left: 10px;
      .el-form-item__label {
        &::before {
          left: -10px;
        }
      }
      .el-form-item__content,
      .el-select,
      .el-date-editor {
        width: 100%;
      }
      .el-input {
        max-width: 90%;
      }
    }
  }
}
.icon {
  width: 16px;
  vertical-align: middle;
  margin-top: -3px;
  margin-left: 5px;
}
.tooltip {
  display: inline-block;
}
</style>
